export default "05b3620674b8812f.svg"